import React from "react";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import { staticPagesTabsData } from "../../../../data/SidebarData";
import Tabs from "../../../../Components/Common/Tabs";
import StaticContactForm from "../StaticContact/Components/StaticContactForm";

const StaticTermsOfService = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={staticPagesTabsData} />
      <StaticContactForm
        title="Terms of Services"
        customSlug="terms-of-services"
        includeSocialLinks={false}
      />
    </div>
  );
};

export default StaticTermsOfService;


